import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HeaderInterceptor } from './config/interceptors/headers.interceptor';
import { registerLocaleData } from '@angular/common';
import localeBr from '@angular/common/locales/pt';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RecaptchaV3Module, RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';
import { environment } from '../environments/environment';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { PdvStoreModule } from './store/pdv/pdv-store.module';
import { LocationStoreModule } from './store/location/location-store.module';
import { SpinnerModule } from './views/components/spinner/spinner.module';
import { MatIconModule } from '@angular/material/icon';
import { DebugComponent } from './debug/debug.component';

registerLocaleData(localeBr, 'pt');

@NgModule({
  declarations: [
    AppComponent,
    DebugComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    RecaptchaV3Module,
    PdvStoreModule,
    LocationStoreModule,
    StoreModule.forRoot({}),
    EffectsModule.forRoot([]),
    StoreDevtoolsModule.instrument({
      maxAge: 100,
      logOnly: environment.production
    }),
    SpinnerModule,
    MatIconModule
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'pt' },
    { provide: HTTP_INTERCEPTORS, useClass: HeaderInterceptor, multi: true, },
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.recaptchaKeyV3 }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
